import React from "react";
import track from "react-tracking";

import AuctionPackages from "../components/Auction/AuctionPackages";

const Auction_Page = () => {
	return (
		<>
			<AuctionPackages />
		</>
	);
};

export const Auction = track(
	{ page: "AuctionPackage" },
	{ dispatchOnMount: (contextData) => ({ event: "pageLoaded" }) }
)(Auction_Page);
